export default [
  {
    value: '',
    label: 'Please Select Your City',
  },
  {
    value: 'Alexandria',
    label: 'Alexandria',
  },
  {
    value: 'Ismailia',
    label: 'Ismailia',
  },
  {
    value: 'Aswan',
    label: 'Aswan',
  },
  {
    value: 'Asyut',
    label: 'Asyut',
  },
  {
    value: 'Luxor',
    label: 'Luxor',
  },
  {
    value: 'Red Sea',
    label: 'Red Sea',
  },
  {
    value: 'Beheira',
    label: 'Beheira',
  },
  {
    value: 'Beni Suef',
    label: 'Beni Suef',
  },
  {
    value: 'Port Said',
    label: 'Port Said',
  },
  {
    value: 'South Sinai',
    label: 'South Sinai',
  },
  {
    value: 'Giza',
    label: 'Giza',
  },
  {
    value: 'Dakahlia',
    label: 'Dakahlia',
  },
  {
    value: 'Damietta',
    label: 'Damietta',
  },
  {
    value: 'Sohag',
    label: 'Sohag',
  },
  {
    value: 'Suez',
    label: 'Suez',
  },
  {
    value: 'Sharqia',
    label: 'Sharqia',
  },
  {
    value: 'North Sinai',
    label: 'North Sinai',
  },
  {
    value: 'Gharbia',
    label: 'Gharbia',
  },
  {
    value: 'Faiyum',
    label: 'Faiyum',
  },
  {
    value: 'Cairo',
    label: 'Cairo',
  },
  {
    value: 'Qalyubia',
    label: 'Qalyubia',
  },
  {
    value: 'Qena',
    label: 'Qena',
  },
  {
    value: 'Kafr El Sheikh',
    label: 'Kafr El Sheikh',
  },
  {
    value: 'Matruh',
    label: 'Matruh',
  },
  {
    value: 'Monufia',
    label: 'Monufia',
  },
  {
    value: 'Minya',
    label: 'Minya',
  },
  {
    value: 'New Valley',
    label: 'New Valley',
  },
];
